import { CapabilityBase } from '@trimble/web3d-capabilities';
import {
  CapabilityProviderBase,
  SharedCapabilityProviderBase,
} from '@trimble/web3d-providers';
import { CapabilityCoordinatorBase } from '../capability-coordinator-base';
import { CapabilityBaseT } from './capability-registry-types';

export function isSharedProvider(
  resource: CapabilityBaseT
): resource is SharedCapabilityProviderBase<CapabilityBase> {
  return resource instanceof SharedCapabilityProviderBase;
}

export function isProvider(
  resource: CapabilityBaseT
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): resource is CapabilityProviderBase<any> {
  return (
    resource instanceof CapabilityProviderBase &&
    !(resource instanceof SharedCapabilityProviderBase)
  );
}

export function isCapability(
  resource: CapabilityBaseT
): resource is CapabilityBase {
  return resource instanceof CapabilityBase;
}

export function isCoordinator(
  resource: CapabilityBaseT
): resource is CapabilityCoordinatorBase {
  return resource instanceof CapabilityCoordinatorBase;
}
